import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const MyTeamAllTravelAndExpensesLink = () => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_team_travel_and_expenses";
  const theme = useTheme();
  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <Typography
          style={{
            color: theme.palette.primary.main,
            fontWeight: "bold",
          }}
        >
          {`${t(`${tRP}.see_all`)}`}
        </Typography>
      </Grid>
    </>
  );
};
export default MyTeamAllTravelAndExpensesLink;
